import { z } from 'zod';

export const ResultLayoutOptions_S = z.literal('grid').or(z.literal('rows'));
